import {Button, IconButton} from "@mui/material";
import {useEffect} from "react";
import {FiPlus, FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import {userColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";
import LoadingContent from "../components/ui/LoadingContent";

const Users = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest({baseUrl: "/users", resource: "users"});

  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async (id) => {
    try {
      await remove(id);
      await list();
    } catch (error) {
      console.error("Error al eliminar el usuario:", error);
    }
  });

  useEffect(() => {
    (async () => {
      try {
        await list();
      } catch (error) {
        console.error("Error al cargar los usuarios:", error);
      }
    })();
    // eslint-disable-next-line
  }, []);

  const handleRowClick = (user) => {
    if (!user?.id) {
      console.error("Error: No se encuentra al usuario");
      return;
    }
    navigate(`/user-form`, {state: {id: user?.id}});
  };

  const handleOpenDeleteDialog = (id) => {
    const found = Array.isArray(data) ? data.find((user) => user.id === id) : null;
    openDialog(id, found?.name || "");
  };

  const columns = [
    ...userColumns,
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              handleOpenDeleteDialog(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return (
    <>
      <Window
        title={"Usuarios"}
        topRightButtons={
          <Button
            variant="contained"
            color="primary"
            startIcon={<FiPlus />}
            onClick={() => {
              navigate(`/user-form`);
            }}
          >
            Nuevo usuario
          </Button>
        }
      >
        {loading ? <LoadingContent /> : <ListView columns={columns} data={data} onRowClick={handleRowClick} />}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="usuario"
        entityLabel={itemName}
      />
    </>
  );
};

export default Users;
